function on(eventName, callback) {
  document.addEventListener(eventName, callback);
}

function clear(eventName, callback) {
  document.removeEventListener(eventName, callback);
}

function fire(eventName) {
  document.dispatchEvent(new Event(eventName));
}

export const EventEmitter = {
  on,
  fire,
  clear,
};
